import LegalPage from "../legal/LegalPage";

const content = {
    ar: {
        title: "سياسة الخصوصية",
        lastUpdated: "آخر تحديث: أغسطس 2026",
        sections: [
            {
                heading: "مقدمة",
                paragraphs: [
                    "نحن في [متجر سليم الشرعبي] نلتزم بحماية خصوصيتك. توضح هذه السياسة كيفية جمعنا واستخدامنا وحمايتنا لبياناتك الشخصية عند استخدامك لموقعنا وخدماتنا.",
                ],
            },
            {
                heading: "البيانات التي نجمعها",
                paragraphs: [ "عند التسجيل أو إتمام عملية شراء، قد نجمع البيانات التالية:" ],
                list: [
                    "الاسم الكامل والبريد الإلكتروني",
                    "رقم الهاتف وعنوان الشحن",
                    "سجل الطلبات والمشتريات",
                    "بيانات الدفع (تُعالج مباشرة عبر بوابة الدفع Moyasar، ولا يتم تخزين بيانات البطاقة على خوادمنا)",
                ],
            },
            {
                heading: "كيف نستخدم بياناتك",
                paragraphs: [ "نستخدم بياناتك للأغراض التالية فقط:" ],
                list: [
                    "معالجة وتوصيل طلباتك",
                    "التواصل معك بخصوص حالة الطلب",
                    "إرسال إشعارات تأكيد الطلب عبر البريد الإلكتروني",
                    "تحسين تجربتك وخدماتنا",
                ],
            },
            {
                heading: "مشاركة البيانات مع أطراف ثالثة",
                paragraphs: [
                    "لا نبيع أو نؤجر بياناتك الشخصية لأي طرف ثالث. قد نشارك بيانات محدودة مع مزودي خدمات موثوقين (مثل بوابة الدفع Moyasar وشركات الشحن) فقط بالقدر اللازم لإتمام خدمتك.",
                ],
            },
            {
                heading: "أمان البيانات",
                paragraphs: [
                    "نتخذ إجراءات تقنية معقولة لحماية بياناتك من الوصول غير المصرح به، بما في ذلك التشفير عبر HTTPS وحماية قواعد البيانات.",
                ],
            },
            {
                heading: "حقوقك",
                paragraphs: [ "لك الحق في الوصول إلى بياناتك، تصحيحها، أو طلب حذفها في أي وقت عبر التواصل معنا." ],
            },
            {
                heading: "التواصل معنا",
                paragraphs: [ "لأي استفسار بخصوص هذه السياسة، يمكنك التواصل معنا عبر:" ],
                list: [ "البريد الإلكتروني: [saleemalfarhany@gmail.com]" ],
            },
        ],
    },
    en: {
        title: "Privacy Policy",
        lastUpdated: "Last updated: August 2026",
        sections: [
            {
                heading: "Introduction",
                paragraphs: [
                    "At [saleem farhan alsharabi], we are committed to protecting your privacy. This policy explains how we collect, use, and protect your personal data when you use our website and services.",
                ],
            },
            {
                heading: "Data We Collect",
                paragraphs: [ "When you register or complete a purchase, we may collect:" ],
                list: [
                    "Full name and email address",
                    "Phone number and shipping address",
                    "Order and purchase history",
                    "Payment data (processed directly via Moyasar; card details are never stored on our servers)",
                ],
            },
            {
                heading: "How We Use Your Data",
                paragraphs: [ "We use your data only for:" ],
                list: [
                    "Processing and delivering your orders",
                    "Communicating with you about your order status",
                    "Sending order confirmation emails",
                    "Improving your experience and our services",
                ],
            },
            {
                heading: "Sharing Data with Third Parties",
                paragraphs: [
                    "We never sell or rent your personal data. We may share limited data with trusted service providers (such as Moyasar payment gateway and shipping companies) only to the extent necessary to fulfill your order.",
                ],
            },
            {
                heading: "Data Security",
                paragraphs: [
                    "We take reasonable technical measures to protect your data from unauthorized access, including HTTPS encryption and database security.",
                ],
            },
            {
                heading: "Your Rights",
                paragraphs: [ "You have the right to access, correct, or request deletion of your data at any time by contacting us." ],
            },
            {
                heading: "Contact Us",
                paragraphs: [ "For any questions about this policy, contact us at:" ],
                list: [ "Email: [saleemalfarhany@gmail.com]" ],
            },
        ],
    },
};

export default function PrivacyPolicy ()
{
    return <LegalPage content={ content } />;
}
